<template>
  <!-- Performance By Service -->
  <div class="md-layout-item md-size-100" v-if="true">
    <DataProvider :endpoint='mountUrlAndParams("statusCount").url' baseUrl='/placeholder' :filter='mountUrlAndParams("statusCount").filter' @success='mountChartBar($event)'>
      <!-- eslint-disable-next-line -->
      <div slot-scope='{ data: response, error, loading }'>
        <SkeletonLoaderChart v-if="loading"/>
        <template v-else>
          <template v-if='error || !dataObj.data.series[0].length'>
            <CardNoData :title="$t('analysisPerServiceDelivered.performanceByService')" :error='error' height='463' />
          </template>
          <chart-card
            v-else
            header-animation="false"
            :chart-data="dataObj.data"
            :chart-options="dataObj.options"
            chart-type="Bar"
            horizontal-bars="true"
            header-icon
            chart-inside-content
            background-color="green"
            :classNameComponent="efficiencyChartStyle"
          >
            <template slot="chartInsideHeader">
              <h4 class="title">{{$t('analysisPerServiceDelivered.performanceByService')}}</h4>
            </template>
            <template slot="footer">
              <div class="md-layout">
                <div class="md-layout-item" style="display: flex">
                  <span>
                    <i class="fa fa-circle text-donnut-blue"></i>
                      {{$t('efficiency.yes')}}
                  </span>
                  <span style="padding: 0px 1rem">
                    <i class="fa fa-circle text-danger"></i>
                      {{$t('efficiency.no')}}
                  </span>
                </div>
              </div>
            </template>
          </chart-card>
        </template>
      </div>
    </DataProvider>
  </div>
</template>

<script>
import DataProvider from '@/components/DataProvider'
import SkeletonLoaderChart from '@/components/Reuse/SkeletonLoaderChart'
import CardNoData from '@/components/CardNoData'
import ChartCard from '@/components/Cards/ChartCard'
import isTenantMixin from '@/components/mixins/isTenantMixin'
import { mapFields } from 'vuex-map-fields'

export default {
  components: {
    DataProvider,
    SkeletonLoaderChart,
    CardNoData,
    ChartCard
  },
  mixins: [isTenantMixin],
  computed: {
    ...mapFields('AnalysisPerServiceDeliveredFilter', ['cpf', 'service', 'returnCode']),
    percentChartStyle () {
      return this.isInss ? 'percentChartInss' : 'percentChart'
    },
    efficiencyChartStyle () {
      return this.isInss ? 'efficiencyChart-inss' : 'efficiencyChart'
    }
  },
  data () {
    return {
      filterDialog: false,
      createButton: require('@/../public/img/plus.png'),
      resetKey: 0,
      dataObj: {
        data: {
          labels: [],
          series: [
            [], []
          ]
        },
        options: {
          height: 0,
          seriesBarDistance: 15,
          reverseData: false,
          horizontalBars: true,
          labelDirection: 'explode',
          axisX: {
            showGrid: false,
            onlyInteger: true
          },
          axisY: {
            offset: 170
          },
          plugins: [
            this.$chartist.plugins
              .tooltip({
                anchorToPoint: true,
                seriesName: true,
                tooltipFnc: this.mountTooltip
              })
              .bind(this),
            this.$chartist.plugins
              .ctBarLabels({
                labelOffset: {
                  x: 4
                }
              })
              .bind(this)
          ]
        }
      }
    }
  },
  methods: {
    mountUrlAndParams (endpoint) {
      const from = this.dateInterval.timestamp1
      const to = this.dateInterval.timestamp2
      return {
        url: `${process.env.VUE_APP_REPORTS_BACKEND}/interactions/services/${endpoint}`,
        filter: { to, from }
      }
    },
    async mountChartBar (response) {
      let maxSize = 0
      this.dataObj.data.labels = []
      this.dataObj.data.series[0] = []
      this.dataObj.data.series[1] = []
      response.data.forEach(row => {
        this.dataObj.data.labels.push(row.key)
        this.dataObj.data.series[0].push({
          meta: row.subtopics[0].key,
          value: row.subtopics[0].total
        })

        this.dataObj.data.series[1].push({
          meta: row.subtopics[1] ? row.subtopics[1].key : this.validateSubtopics(row.subtopics[0].key),
          value: row.subtopics[1] ? row.subtopics[1].total : ''
        })

        this.dataObj.options.height = response.data.length * 100

        if (row.key.length > maxSize) {
          maxSize = row.key.length
        }
      })

      const deltaSize = maxSize * 8

      this.dataObj.options.axisY.offset = deltaSize
      if (deltaSize < 100) {
        this.dataObj.options.axisY.offset = 100
      }

      if (deltaSize > 250) {
        this.dataObj.options.axisY.offset = 250
      }
    },
    validateSubtopics (key) {
      if (key === 'sim') {
        return 'não'
      }
      return 'sim'
    },
    mountTooltipPie (meta, value) {
      let tooltipMeta = "<span style='font-weight: bold'>" + meta + '</span>'
      let tooltipValue = '<span> Valor: ' + value + '% </span>'
      return tooltipMeta + '<br/>' + tooltipValue
    }
  }
}
</script>
